import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import PinLogin from "@/pages/PinLogin";
import OwnerLogin from "@/pages/OwnerLogin";
import UnternehmerLayout from "@/pages/UnternehmerLayout";
import UnternehmerDashboard from "@/pages/UnternehmerDashboard";
import Mitarbeiter from "@/pages/Mitarbeiter";
import MitarbeiterDetail from "@/pages/MitarbeiterDetail";
import Unterweisungen from "@/pages/Unterweisungen";
import Pruefmappe from "@/pages/Pruefmappe";
import NachweisView from "@/pages/NachweisView";
import MonteurAufgaben from "@/pages/MonteurAufgaben";
import MonteurHome from "@/pages/MonteurHome";
import MonteurSuche from "@/pages/MonteurSuche";
import MonteurEinstellungen from "@/pages/MonteurEinstellungen";
import MonteurAufgabe from "@/pages/MonteurAufgabe";
import MonteurWelt from "@/pages/MonteurWelt";
import MonteurAushang from "@/pages/MonteurAushang";
import MonteurHandschutzplan from "@/pages/MonteurHandschutzplan";
import MonteurFuehrerschein from "@/pages/MonteurFuehrerschein";
import UnternehmerFuehrerschein from "@/pages/UnternehmerFuehrerschein";
import AushangPflicht from "@/pages/AushangPflicht";
import Handschutzplan from "@/pages/Handschutzplan";
import HandschutzplanDetail from "@/pages/HandschutzplanDetail";
import HandschutzplanPlakat from "@/pages/HandschutzplanPlakat";
import Gefahrstoffverzeichnis from "@/pages/Gefahrstoffverzeichnis";
import Einstellungen from "@/pages/Einstellungen";
import Welt from "@/pages/Welt";
import WeltPlakat from "@/pages/WeltPlakat";
import OpsConsole from "@/pages/OpsConsole";
import PreviewImages from "@/pages/PreviewImages";
import Legal from "@/pages/Legal";
import LandingPage from "@/pages/landing/LandingPage";
import AbschlussVorschau from "@/pages/landing/AbschlussVorschau";
import EinmalkaufReturn from "@/pages/landing/EinmalkaufReturn";
import AbschlussseiteV2 from "@/pages/abschluss/AbschlussseiteV2";
import AboSeite from "@/pages/abo/AboSeite";
import AbschlussPreviewDev from "@/pages/abschluss/AbschlussPreviewDev";
import Lp3ChrisDevPreview from "@/pages/dev/Lp3ChrisDevPreview";
import WeltChrisDevPreview from "@/pages/dev/WeltChrisDevPreview";
import AboB4VariantsDev from "@/pages/dev/AboB4VariantsDev";
import AboWiedervorlageDev from "@/pages/dev/AboWiedervorlageDev";
import AboWvStageDev from "@/pages/dev/AboWvStageDev";
import AboDeviceDevPreview from "@/pages/dev/AboDeviceDevPreview";
import AboDevicePhotoDevPreview from "@/pages/dev/AboDevicePhotoDevPreview";
import AboGefahrstoffDevPreview from "@/pages/dev/AboGefahrstoffDevPreview";
import AboB3DevPreview from "@/pages/dev/AboB3DevPreview";
import AboFuehrerscheinDevPreview from "@/pages/dev/AboFuehrerscheinDevPreview";
import AboPruefmappeDevPreview from "@/pages/dev/AboPruefmappeDevPreview";
import AboPreisAbschlussDevPreview from "@/pages/dev/AboPreisAbschlussDevPreview";
import { isDevPreviewEnabled } from "@/lib/devPreview";
import UnterweisungsnachweisDruck from "@/pages/UnterweisungsnachweisDruck";
import RootRoute from "@/components/RootRoute";
import { EmployeeSessionProvider } from "@/hooks/useEmployeeSession";
import { OwnerSessionProvider } from "@/hooks/useOwnerSession";
import ProtectedMonteurRoute from "@/components/ProtectedMonteurRoute";
import ProtectedOwnerRoute from "@/components/ProtectedOwnerRoute";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <OwnerSessionProvider>
        <EmployeeSessionProvider>
          <Routes>
            {/* P1 (Juni 2026): Standard-Einstieg. Nicht eingeloggt → Landingpage,
               eingeloggter Owner → /unternehmer, eingeloggter Mitarbeiter →
               /monteur. Kanonische Live-Domain: clartext.io. */}
            <Route path="/" element={<RootRoute />} />
            {/* Rückwärtskompatibel: alte Rollen-Auswahl-Seite (u. a. Mitarbeiter-
               Einstieg) bleibt unter /login erreichbar. */}
            <Route path="/login" element={<Login />} />

            {/* Unternehmer-Bereich – PIN-geschützt (Sprint A.5) */}
            <Route path="/unternehmer/login" element={<OwnerLogin />} />
            <Route
              path="/unternehmer"
              element={
                <ProtectedOwnerRoute>
                  <UnternehmerLayout />
                </ProtectedOwnerRoute>
              }
            >
              <Route index element={<UnternehmerDashboard />} />
              <Route path="mitarbeiter" element={<Mitarbeiter />} />
              <Route path="mitarbeiter/:id" element={<MitarbeiterDetail />} />
              <Route path="unterweisungen" element={<Unterweisungen />} />
              <Route path="pruefmappe" element={<Pruefmappe />} />
              <Route path="aushang" element={<AushangPflicht />} />
              {/* CLARTEXT · Fuehrerscheinkontrolle · Block F (Feb 2026):
                 Mandanten-Freigabe-Seite. Eigener Sidebar-Eintrag mit Badge
                 (Frage 8a + Frage 9-Antwort). Rein additiv. */}
              <Route path="fuehrerschein" element={<UnternehmerFuehrerschein />} />
              {/* Handschutzplan-Modul · Baustein 5 (Aug 2026): Drill-down
                 Übersicht + Detail je Einsatzbereich. hazmat_addon-gegated
                 (Server-Gate 403 + Sidebar-Gate). Rein additiv. */}
              <Route path="handschutzplan" element={<Handschutzplan />} />
              <Route
                path="handschutzplan/:einsatzbereichId"
                element={<HandschutzplanDetail />}
              />
              {/* Gefahrstoffverzeichnis · Owner-Leseansicht (Aug 2026,
                 § 6 GefStoffV). hazmat_addon-gegated (Server-Gate 403 +
                 Sidebar-Gate). Rein additiv, nur Leseansicht. */}
              <Route
                path="gefahrstoffverzeichnis"
                element={<Gefahrstoffverzeichnis />}
              />
              <Route path="einstellungen" element={<Einstellungen />} />
              <Route path="welt/:id" element={<Welt />} />
              <Route path="nachweis/:id" element={<NachweisView />} />
            </Route>

            {/* DEMO-SAFE-3 (Juni 2026): druckbare Plakatansicht – eigene Route
               OHNE Layout-Navigation (sauberer Browser-Druck). Owner-geschützt,
               rein additiv, beweisneutral. */}
            <Route
              path="/unternehmer/welt/:id/plakat"
              element={
                <ProtectedOwnerRoute>
                  <WeltPlakat />
                </ProtectedOwnerRoute>
              }
            />

            {/* STUFE 8H (ADR React-Print): interne Druckansicht der Arbeits-
               schutzmappe — DIESELBE Welt-Komponente, eigene Route OHNE
               Layout-Shell (Muster Plakat-Route). Daten nur mit gültigem
               bezahltem Renderkontext (token+attempt, serverseitig geprüft). */}
            <Route
              path="/druck/arbeitsschutzmappe/:token/:attempt"
              element={<Welt druckansicht />}
            />

            {/* STUFE V4D (Betreiberentscheidung V4B): interne Druckansicht des
               eigenständigen Unterweisungsnachweises (Tür 1) — eigene Route
               OHNE Layout-Shell (Muster 8H). Daten nur mit gültigem bezahltem
               Renderkontext (token+attempt, serverseitig geprüft). */}
            <Route
              path="/druck/unterweisungsnachweis/:token/:attempt"
              element={<UnterweisungsnachweisDruck />}
            />

            {/* PLAKAT-PDF (2026-06, Betreiberfreigaben 1a/2b): interne
               Druckansicht des Unterweisungsplakats — DIESELBE Plakat-
               Komponente, eigene Route OHNE Layout-Shell (Muster 8H/V4D).
               Daten nur mit gültigem kurzlebigem Render-Token (serverseitig
               erzeugt, zweckgebunden, fail-closed). */}
            <Route
              path="/druck/plakat/:token"
              element={<WeltPlakat druckansicht />}
            />
            {/* Handschutzplan-Modul · Baustein 6 (Aug 2026): interne Plakat-
               Druckansicht — nur mit gültigem kurzlebigem Render-Token
               (Muster identisch zu /druck/plakat, eigenständige Pipeline). */}
            <Route
              path="/druck/handschutzplan/:token"
              element={<HandschutzplanPlakat />}
            />

            {/* Mitarbeiter-Bereich – PIN-geschützt (Phase 6) */}
            <Route path="/monteur/login" element={<PinLogin />} />
            {/* KARTEN-HOME · Teil 1 (Juni 2026, betreibergenehmigt):
                /monteur ist jetzt der Karten-Hub; die Unterweisungsliste
                (frühere Startseite) lebt auf /monteur/aufgaben, die
                Nachschlage-Suche auf /monteur/suche. QR-Deeplinks
                (?welt= → /monteur/welt/:id) bleiben unverändert. */}
            <Route
              path="/monteur"
              element={
                <ProtectedMonteurRoute>
                  <MonteurHome />
                </ProtectedMonteurRoute>
              }
            />
            <Route
              path="/monteur/aufgaben"
              element={
                <ProtectedMonteurRoute>
                  <MonteurAufgaben />
                </ProtectedMonteurRoute>
              }
            />
            <Route
              path="/monteur/suche"
              element={
                <ProtectedMonteurRoute>
                  <MonteurSuche />
                </ProtectedMonteurRoute>
              }
            />
            {/* Mitarbeiter-Einstellungen · Teil 2 (Juni 2026). */}
            <Route
              path="/monteur/einstellungen"
              element={
                <ProtectedMonteurRoute>
                  <MonteurEinstellungen />
                </ProtectedMonteurRoute>
              }
            />
            <Route
              path="/monteur/aufgabe/:id"
              element={
                <ProtectedMonteurRoute>
                  <MonteurAufgabe />
                </ProtectedMonteurRoute>
              }
            />
            <Route
              path="/monteur/welt/:id"
              element={
                <ProtectedMonteurRoute>
                  <MonteurWelt />
                </ProtectedMonteurRoute>
              }
            />
            {/* CLARTEXT · A1-B UX-Fix (Feb 2026): Mitarbeiter-Aushangseite.
                Zuvor war der Link `to="/monteur/aushang"` in MonteurAufgaben.jsx
                korrekt gesetzt, aber ohne Route-Registrierung wurde der Klick
                vom Catch-All `Navigate to="/"` (Zeile weiter unten) auf die
                Rootroute und damit auf `/unternehmer` bzw. `/monteur` umgeleitet. */}
            <Route
              path="/monteur/aushang"
              element={
                <ProtectedMonteurRoute>
                  <MonteurAushang />
                </ProtectedMonteurRoute>
              }
            />
            {/* Handschutzplan-Modul · Baustein 9 (Feb 2026): Mitarbeiter-
                Leseansicht je Einsatzbereich. Modul-Gate serverseitig
                (MODULE_HAZMAT); Frontend blendet die Karte im Empty-
                Response-Fall lautlos aus. */}
            <Route
              path="/monteur/handschutzplan/:einsatzbereichId"
              element={
                <ProtectedMonteurRoute>
                  <MonteurHandschutzplan />
                </ProtectedMonteurRoute>
              }
            />
            {/* CLARTEXT · Fuehrerscheinkontrolle · Block D (Feb 2026):
               Mitarbeiter-App-Seite fuer Foto-Upload + Erklaerung.
               Isoliert, ausschliesslich fuer Mitarbeiter mit is_driver=true.
               Zero-Interpretation: nur additive Route, keine Aenderung an
               den bestehenden Monteur-Seiten. */}
            <Route
              path="/monteur/fuehrerschein"
              element={
                <ProtectedMonteurRoute>
                  <MonteurFuehrerschein />
                </ProtectedMonteurRoute>
              }
            />

            {/* P4 (Juni 2026): Betreiber-/Admin-Konsole. SEPARAT geschützt über
               OPS_API_TOKEN-Eingabe (kein Owner-/Employee-Login). Bewusst NICHT
               in der normalen Navigation verlinkt. */}
            <Route path="/ops" element={<OpsConsole />} />

            {/* IMPLEMENT-11 (Juni 2026): KI-Lehrbild-Prototyp. NUR für Owner
               (ProtectedOwnerRoute). Isoliert/additiv – kein Produktivflow,
               kein WORM/Evidence/PDF/content_hash betroffen. */}
            <Route
              path="/preview-images"
              element={
                <ProtectedOwnerRoute>
                  <PreviewImages />
                </ProtectedOwnerRoute>
              }
            />


            {/* LP3 (Juni 2026): Öffentliche Marketing-Landingpage mit echter,
               read-only KI-Vorschau. ISOLIERT/additiv – verändert keine
               bestehende Route oder App-Flow. */}
            <Route path="/lp3" element={<LandingPage />} />

            {/* Interne Vorschau (Juni 2026): zeigt NUR die Abschlussseite
               (ConversionBlock) ohne Demo-Flow. Rein additiv, eigener Pfad,
               bewusst NICHT in Navigation/SEO verlinkt. */}
            <Route path="/vorschau/abschluss" element={<AbschlussVorschau />} />

            {/* D12 (Tür 1, Juli 2026): Rückkehrseite nach dem anonymen PDF-Einmalkauf
               (Stripe mode=payment). Rein additiv, ohne Konto/Auth. */}
            <Route path="/einmalkauf" element={<EinmalkaufReturn />} />

            {/* UI-V1 (Feb 2026): Pixelgetreue React-Überführung des statischen
               Design-Prototyps /abschluss-prototyp-v2.html. Rein additiv, keine
               funktionale Anbindung (kein Katalog, kein Stripe, keine Buttons
               scharf). Der HTML-Prototyp bleibt in UI-V1 als Vergleichsreferenz
               unverändert erhalten. Nachfolgestufe UI-V2 verkabelt die CTAs. */}
            <Route path="/abschluss-v2" element={<AbschlussseiteV2 />} />

            {/* Dev-only (Sep 2026): Direktvorschau der Abschlussseite mit
               Beispieldaten, OHNE Welterzeugung/Flow — nur in Preview-/Dev-
               Umgebung registriert (Hostname-Gate in lib/devPreview.js).
               In Produktion greift der Catch-All unten (Redirect auf "/"). */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abschluss-preview" element={<AbschlussPreviewDev />} />
            )}

            {/* Dev-only (Sep 2026): Chris-LP3-Warteerfahrung ohne echten KI-Lauf.
               Query: ?q=<Begriff>&ready=<ms>&reduced=1. Nur Preview-/Dev-Umgebung. */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/lp3-chris" element={<Lp3ChrisDevPreview />} />
            )}

            {/* Dev-only (Juni 2026, Chris Phase C1): Readiness-Aktivität der
               Dokumentenwelt in allen echten Zuständen (RUNNING/BLOCKED/READY)
               + Reduced-Motion, ohne echten KI-/Bildlauf. Query: ?status=…&reduced=1. */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/welt-chris" element={<WeltChrisDevPreview />} />
            )}

            {/* Dev-only (Juni 2026, /abo B4 „Lernkontrolle"): 3 Entscheidungs-
               varianten (V1/V2/V3) des echten Frage-Screens zum Vergleich.
               KEINE /abo-Bühne. Wird nach Variantenwahl entfernt. */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-b4-variants" element={<AboB4VariantsDev />} />
            )}

            {/* Dev-only (Juni 2026, /abo „Wiedervorlage/Wiederholung/Ampel"): Crop B
               „Entlastung" als Desktop- + Mobile-Vorschau. KEINE /abo-Bühne. */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-wiedervorlage" element={<AboWiedervorlageDev />} />
            )}

            {/* Dev-only: isolierte Prüfung der ECHTEN /abo-Bühne (Komponente + abo.css). */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-wv-stage" element={<AboWvStageDev />} />
            )}

            {/* Dev-only: Device Presentation Pass 01 (iMac-Look B1 + B4). */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-device" element={<AboDeviceDevPreview />} />
            )}

            {/* Dev-only: Device Pass 01 – FOTOREALISTISCHE Geräte (B1 + B4). */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-device-photo" element={<AboDevicePhotoDevPreview />} />
            )}

            {/* Dev-only (Sep 2026): Gefahrstoff-Bühne (Preview) im Frozen Standard. */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-gefahrstoff" element={<AboGefahrstoffDevPreview />} />
            )}

            {/* Dev-only (Sep 2026): B3 Mitarbeiterzugang (Preview) im Frozen Standard. */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-b3" element={<AboB3DevPreview />} />
            )}

            {/* Dev-only (Sep 2026): Führerschein-Bühne (Preview) — Hauptmotiv 1:1. */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-fuehrerschein" element={<AboFuehrerscheinDevPreview />} />
            )}

            {/* Dev-only (Sep 2026): Prüfmappe-Bühne (Preview) — CL-Mac + reale BG-Struktur. */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-pruefmappe" element={<AboPruefmappeDevPreview />} />
            )}

            {/* Dev-only (30.09.2026): Preis-/Abschlussbühne (Preview) — freigegebenes
               Design-PNG 1:1 als Master-Bild + unsichtbare Hotspots (Trial · PDF)
               + Live-Preisrechner-Overlay aus /api/catalog. Live /abo unberührt. */}
            {isDevPreviewEnabled() && (
              <Route path="/dev/abo-preis" element={<AboPreisAbschlussDevPreview />} />
            )}

            {/* G1 (Juni 2026): Rechtliche Pflichtseiten (technische Platzhalter).
               Öffentlich – KEIN Login nötig (DSGVO/§5 DDG verlangen freie
               Erreichbarkeit). Inhalt fügt der Betreiber vor Go-live ein. */}
            <Route path="/impressum" element={<Legal pageTitle="Impressum" pageKey="impressum" />} />
            <Route path="/datenschutz" element={<Legal pageTitle="Datenschutzerklärung" pageKey="datenschutz" />} />
            <Route path="/agb" element={<Legal pageTitle="Allgemeine Geschäftsbedingungen" pageKey="agb" />} />
            <Route path="/avv" element={<Legal pageTitle="Auftragsverarbeitungsvertrag" pageKey="avv" />} />

            {/* B2-B (Juni 2026): Vollständige, geführte Abo-Produktseite (Hero,
               reale Screenshots, Chris 21/22/23, Plakat-Viewer, Live-Preis aus
               /api/catalog, Trial-Start). Ziel von Tür A der Abschlussseite. */}
            <Route path="/abo" element={<AboSeite />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </EmployeeSessionProvider>
      </OwnerSessionProvider>
    </BrowserRouter>
  );
}

export default App;
